const MODALITY_TEXT = Object.freeze({
    in_person: 'In person',
    online: 'Online',
    hybrid: 'Hybrid',
});

export function positionCourse(position) {
    return [position?.subject, position?.courseNumber]
        .filter(Boolean)
        .join(' ');
}

export function positionHeading(position) {
    const course = positionCourse(position);
    const lead = [course, position?.title].filter(Boolean).join(': ');
    const section = position?.section ? `section ${position.section}` : '';
    const heading = [lead, section].filter(Boolean).join(', ');
    return heading || 'A position';
}

export function meetingLines(meetings) {
    return (meetings || []).map((m) => {
        const when = [m.days, m.time].filter(Boolean).join(' ');
        const base = m.type ? `${m.type}: ${when}` : when;
        return m.room ? `${base}, room ${m.room}` : base;
    });
}

export function modalityText(modality) {
    if (!modality) return '';
    return MODALITY_TEXT[modality] || modality;
}

/** Meeting days and times without the room: "Lecture: MWF 10:00-10:50". */
export function meetingTimeLines(meetings) {
    return (meetings || [])
        .map((m) => {
            const when = [m.days, m.time].filter(Boolean).join(' ');
            return m.type && when ? `${m.type}: ${when}` : when;
        })
        .filter(Boolean);
}

/**
 * When a position meets, one line per meeting. With no days and times set
 * the line says why: an online section may have no set meeting time.
 */
export function meetingSummaryLines(position) {
    const lines = meetingTimeLines(position?.meetings);
    if (lines.length > 0) return lines;
    return [
        position?.modality === 'online'
            ? 'Online, no set meeting time'
            : 'Meeting times not set yet',
    ];
}

/** "Online" for an online section, else the rooms it meets in, else ''. */
export function locationText(position) {
    if (position?.modality === 'online') return 'Online';
    const rooms = [
        ...new Set(
            (position?.meetings || []).map((m) => m.room).filter(Boolean)
        ),
    ];
    if (rooms.length > 0) return rooms.join(', ');
    return modalityText(position?.modality);
}
